


























































































































































































































































































import Vue from "vue";
import { Watch, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import { AppMenus as _menu } from '@/shared/app.menu';
import LeftNavigationComponent from "../../Workspace/Components/LeftNavigation.vue";
import FinancialReportSummary from "./Components/Summary.vue";
import TransactionList from './Components/TransactionList.vue';
import PersonnelCost from './Components/PersonnelCost.vue';
import Forecast from './Components/Forecast.vue';
import DetailedListing from './Components/DetailedListing.vue';
import ExpenditureStatement from './Components/ExpenditureStatement.vue';
import Consolidation from './Components/Consolidation.vue';
import FinDocs from './Components/FinDocs.vue';
import DetailedExpense from './Components/DetailedExpenses.vue';
import SummaryReport from './Components/SummaryReport.vue';
import SummaryTable from './Components/SummaryTable.vue';
import CashFlowProjection from './Components/CashFlowProjection.vue';
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import PermissionService from '@/services/permission.service';
import { Feedback, FinancialReportData } from "@/entities";
import { Locales } from "@/i18n/locales";
// import { forEach } from "lodash";
import AuthService from "@/services/auth.service";
import { User } from "oidc-client";
const auth = new AuthService();

const permissionService = new PermissionService();
const namespace: string = "financialReport";

@Component ({
    components: {
        LeftNavigationComponent,
        FinancialReportSummary,
        TransactionList,
        PersonnelCost,
        Forecast,
        Consolidation,
        DetailedListing,
        ExpenditureStatement,
        FinDocs,
        ValidationMessageComponent,
        DetailedExpense,
        SummaryReport,
        SummaryTable,
        CashFlowProjection
    }
})
export default class FinanciallReportWorkspaceComponent extends Vue {

    @State(namespace) financialReport!: FinancialReportData;
    @State("feedback") feedback!: Feedback;
    @Action("getFinancialReport", { namespace }) getReport: any;
    @Action("getGrantInfo", { namespace }) getGrantData: any;
    @Action("saveFinancialReport", { namespace }) saveReport: any;
    @Action("saveFinancialReportData", { namespace }) saveReportData: any;
    @Action("saveFinancialReportDirty", { namespace }) saveReportDirty: any;
    @Action("updateSelectedKey", { namespace }) setActiveKey: any;
    @Getter("financialReportSections", { namespace }) financialReportSections: any;
    @Action("uploadDocument", { namespace }) uploadDocument: any;
    @Action("getFeedbackInfo", { namespace: "feedback" }) getFeedbackInfo: any;
    @Action("createFeedbackHeader", { namespace: "feedback" }) createFeedbackHeader: any;
    @Action("showNotification", { namespace: 'application' }) showNotification: any
    @Action("getFeedbacks", { namespace: "feedback" }) getFeedbacks: any;
    @Action("resolve", { namespace: "feedback" }) resolveFeedback: any;
    @Action("uploadReport", { namespace }) uploadReport: any;
    @Action("reopen", { namespace: "feedback" }) reopenFeedback: any;
    @Action('getAppBudgetForGrant', {namespace}) getAppBudgetForGrant: any;
    @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
    @Getter("_appUserId", { namespace: "RootApp" } ) _userid!: number;

    // selectedKey: string = Object.keys(this.subSections.properties)[0];
    docTags: any = [];
    showSideBar = true;
    isDirty = false;
    reportLength = 0;
    finReports = [];
    actions = _app.actions;
    subjects = _app.subjects;
    summaryKey = 0;
    enabledStatuses = [
        _app.finReportStatus.notStarted,
        _app.finReportStatus.inProgress,
        _app.finReportStatus.waitingLP,
        _app.finReportAuditStatus.notStarted,
        _app.finReportAuditStatus.inProgress
    ];
    uploadedData:any
    forecastValidations = [];
    personnelCostValidations = [];
    transactionValidations: any = [];
    detailedListingValidations = [];
    expStatementValidations = [];
    detailedExpenseValidations = [];
    summaryReportValidations = [];
    finReportpending = _app.finReportStatus.pendingReview;
    ppoAccess:boolean = false;
    initiativeId:number = 0;
    finReportStatus = _app.finReportStatus;
    finReportAuditStatus = _app.finReportAuditStatus;
    role_id: any;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;
    validationImport:boolean = false;
    
    enableButton() {
        const self = this;
        //@ts-ignore
        if(self.financialReport.selectedReport.WorkFlowStatusId != this.finReportStatus.terminated && this.$can(this.actions.update, this.subjects.grantReports) 
            && (this.enabledStatuses.includes(this.financialReport.selectedReport.WorkFlowStatusId)
            || (self.financialReport.selectedReport.WorkflowInfo
            && self.financialReport.selectedReport.WorkflowInfo.CurrentStep
            && self.financialReport.selectedReport.WorkflowInfo.CurrentStep.ReturnStatus))
        ) {
            // for applicants
            return true;
        }
        //@ts-ignore
        else if ((self.financialReport.selectedReport.WorkFlowStatusId != this.finReportStatus.terminated && this.$can(this.actions.fullaccess, this.subjects.all) || this.$can(this.actions.manage, this.subjects.program) || this.ppoAccess) &&
        (self.enabledStatuses.includes(this.financialReport.selectedReport.WorkFlowStatusId)
            || (self.financialReport.selectedReport.WorkflowInfo
            && self.financialReport.selectedReport.WorkflowInfo.CurrentStep
            && self.financialReport.selectedReport.WorkflowInfo.CurrentStep.ReturnStatus))) {
            // show button for program admins and system admins
            return true;
        }
        //@ts-ignore
        // else if(this.$can(this.actions.read, this.subjects.grantReports) && self.financialReport.selectedReport.WorkFlowStatusId === self.finReportpending)
        //     return true;
    }

    @Watch("initiativeId")
    ppoPermission(val: any) {
        if (val) {
            this.ppoHasPermission(val);
        } else {
            this.ppoAccess = false;
        }
    }

    ppoHasPermission(initiativeId) {
        // Get logged in user initiatives
        permissionService.ppoHasPermission(initiativeId).then((hasPermission: boolean) => {
            // get user initiaive
            this.ppoAccess = hasPermission;
        });
    }

    downloadTemp(e){
       let reportID=this.financialReport.selectedReport.FinancialReportId
       let grantId=this.financialReport.grantData.grantId
       let fileName=`Financial_Report_${this.financialReport.selectedReport.Title}_${this.financialReport.grantInfo.GrantCode}`
       this.$services.monitor.downloadTemplate(reportID, grantId,fileName)
    }
    exportReport(e)
    {
       let reportID=this.financialReport.selectedReport.FinancialReportId
       let appId=this.financialReport.grantData.applicationId
       let grantId=this.financialReport.grantData.grantId
       let fileName=`Financial_Report_${this.financialReport.selectedReport.Title}_${this.financialReport.grantInfo.GrantCode}`
       this.$services.monitor.exportReport(reportID, grantId,fileName)
       //this.$services.monitor.downloadFile(reportID,GrantId,appId)
    }
    
    /** on file upload */
    onAddFiles(e){
      let file=e.file
      let type=e.type
      let reportId=this.financialReport.selectedReport.FinancialReportId
      let appId=this.financialReport.grantData.applicationId
      let errFlag: boolean = false;
      var self = this;
      this.validationImport = true;
      this.uploadReport({ file, reportId, appId, type }).then((data)=>{
        self.isDirty = true;
       if(data.ForecastResponse!=null){
        self.dataModel.forecast=data.ForecastResponse.Record
        self.forecastValidations = data.ForecastResponse.SeriesValidation;
           if(self.forecastValidations && self.forecastValidations.length > 0) {
                errFlag = true;
            } 
       }
       if(data.PersonnelCostResponse!=null){
        self.dataModel.personnelCost=data.PersonnelCostResponse.PersonnelCosts;
        self.generateRowIds(self.dataModel.personnelCost);
        self.personnelCostValidations = data.PersonnelCostResponse.Validation;
            if(self.personnelCostValidations && self.personnelCostValidations.length > 0)
                errFlag = true;
       }
       if(data.TransactionListingResponse!=null){
        self.dataModel.transactions=data.TransactionListingResponse.TransactionListings;
        self.generateRowIds(self.dataModel.transactions);
        self.transactionValidations = data.TransactionListingResponse.Validation;
            if(self.transactionValidations && self.transactionValidations.length > 0)
                errFlag = true;
       }
       if(data.DetailedListingResponse!=null){
        self.dataModel.detailedListing =data.DetailedListingResponse.DetailedListings;
        self.generateRowIds(self.dataModel.detailedListing);
        self.detailedListingValidations = data.DetailedListingResponse.Validation;
            if(self.detailedListingValidations && self.detailedListingValidations.length > 0)
                errFlag = true;
       }
       if(data.StatementOfExpenditureResponse!=null){
        self.dataModel.statementOfExpeditures =data.StatementOfExpenditureResponse.StatementOfExpenditures
        self.expStatementValidations = data.StatementOfExpenditureResponse.Validation;
            if(self.expStatementValidations && self.expStatementValidations.length > 0)
                errFlag = true;
       }
       if(data.ConsolidationResponse!=null){
        self.dataModel.consolidation =data.ConsolidationResponse.Consolidation;
            // this.expStatementValidations = data.StatementOfExpenditureResponse.Validation;
            // if(this.expStatementValidations && this.expStatementValidations.length > 0)
            //     errFlag = true;
       }
       if(data.DetailedExpensesResponse != null) {
        self.dataModel.detailedExpenses = data.DetailedExpensesResponse.DetailedExpense;
        self.generateRowIds(self.dataModel.detailedExpenses);
        self.detailedExpenseValidations = data.DetailedExpensesResponse.Validation;
           if (self.detailedExpenseValidations && self.detailedExpenseValidations.length > 0)
                errFlag = true;
       }
       if(data.SummaryReportResponse != null) {
        self.dataModel.summary.summaryReport = data.SummaryReportResponse.SummaryReport;
        self.summaryReportValidations = data.SummaryReportResponse.Validation;
           if (self.summaryReportValidations && self.summaryReportValidations.length > 0)
                errFlag = true;
       }
        if(errFlag)
        self.showNotification({
                text: self.$t('File imported with errors. Please see respective tabs for error details.'),
                isHtml: true,
                color: "error"
            });
        else
        self.showNotification({
                text: self.$t('File imported successfully.'),
                isHtml: true,
                color: "success"
            });
      })
    }
    mounted() {  
      auth.isLoggedIn().then((isLoggedIn) => {
        if (isLoggedIn) {
              auth.getUser().then((user: User) => {                
                this.role_id = user.profile.role_id;                                    
              });
          }          
      });              
    }

    TransformForecast(record : any){
      return record;
    }
    getCurrencyCode(value)
    {
      let currencyObj=this.financialReport.currencyList.find(x=>x.DisplayText==value)
      return currencyObj
    }

    topmenuChanged(key) {
        this.saveDirty(() => {
            this.setActiveKey(key);
            window.location.hash = `#${key}`;
        });
    }

    /** set is-dirty flag  */
    setDirtyFlag(flag: boolean) {
        this.isDirty = flag;
    }
    
    sidebarToggle() {
        this.showSideBar = !this.showSideBar;
    }

    get formOptions() {        
        return {
            "uploadAction": this.uploadDocument,
            "removeAction": this.$services.document.removeDocument,
            "downloadAction": this.$services.document.download,
            "locale": this.defaultLocale,
            "ApplicationId": this.financialReport.selectedReport.FinancialReportId,
            "baseURI": process.env.VUE_APP_API_Base_URL,
            //@ts-ignore
            "rights": this.$can("manage", "feedback") ? _app.actions.manage : _app.actions.read,
            "entity": _app.entities.finReport,
            "feedbacks": this.feedback.feedbackHeaders,
            "transactionId": this.financialReport.selectedReport.FinancialReportId,
            "user": this._userid,
            "fileSizeLimit": this.appSettings.MaxFileSizeLimit,
            "actions": {
                createHeader: this.createFeedbackHeader,
                list: this.getFeedbacks,
                resolveFeedback: this.resolveFeedback,
                reopenFeedback: this.reopenFeedback,
                updateFeedback: this.$services.comment.Update
            },
            //@ts-ignore
            disableAll: (((this.$can(this.actions.update, this.subjects.grantReports) || this.$can(this.actions.fullaccess, this.subjects.all)) &&
                ([
                    this.finReportStatus.readyForAudit,
                    this.finReportStatus.readyForValidation,                    
                    this.finReportStatus.approved,
                    this.finReportStatus.terminated,
                    this.finReportAuditStatus.readyForAudit,
                    this.finReportAuditStatus.validated,
                    this.finReportAuditStatus.approved,
                    this.finReportAuditStatus.terminated,
                    this.finReportStatus.pendingReview,
                    this.finReportAuditStatus.pendingReview,
                ].includes(this.financialReport.selectedReport.WorkFlowStatusId) &&                
                this.financialReport.selectedReport.WorkflowInfo.CurrentStep.ReturnStatus !== 1 ? true: false)) || (this.role_id == _app.appRoles.Auditor)),
            //@ts-ignore
            canViewSampleDoc: this.$can(this.actions.read, this.subjects.finReport) &&
                [
                    this.finReportAuditStatus.readyForAudit,
                    this.finReportAuditStatus.approved,
                    this.finReportAuditStatus.terminated
                ].includes(this.financialReport.selectedReport.WorkFlowStatusId),
            //@ts-ignore
            canManageSampleDoc: this.$can(this.actions.update, this.subjects.finReport) &&
                this.financialReport.selectedReport.WorkFlowStatusId == this.finReportAuditStatus.readyForAudit &&
                this.financialReport.selectedReport.WorkflowInfo.CurrentStep.ReturnStatus == 1
                
        };
    }

    /** Return grant agreement sub sections */
    get subSections() {
        return this.financialReportSections || {};
    }

    get subSchema() {
        if(this.subSections && this.subSections.properties) {
           return this.subSections.properties[this.financialReport.selectedKey];
        }
    }

    get budgetInfo() {
        if (this.financialReport.grantData && this.financialReport.grantData.applicationBudget) {
            return this.financialReport.grantData.applicationBudget;
        }
    }

    get dataModel() {
        const self = this;
        return self.financialReport.grantData.finReport.find(x => x.FinancialReportId === self.financialReport.selectedReport.FinancialReportId);
    }

    get forecastModel() {
        const self = this;
        return self.financialReport.grantData;
    }

    /*save after file upload*/
    fileChanged(e)
    {
        if(this.enableButton()) 
        {
            this.saveData()
        }
    }

    /*** save if form is dirty */
    saveDirty(callback: any) {
        const self = this;
        let errFlag: boolean = false;
        let selectedReport = self.financialReport.selectedKey;
        this.validationImport = false;
        if(this.isDirty && this.enableButton()) {
            // save the data if form is dirty
            this.setDirtyFlag(false);
            let result = this.$services.monitor.transformAppData(self.financialReport.grantData);
            if(self.financialReport.applicationBudgetForGrant){
                result = self.$services.monitor.mergeBudgetSummary(result, self.financialReport.applicationBudgetForGrant, self.financialReport.selectedReport.FinancialReportId);
            }
            this.saveReportDirty({
                data: result,
                id: self.financialReport.selectedReport.GrantId,
                reportId: self.financialReport.selectedReport.FinancialReportId,
                context: 'save',
                section: selectedReport
            })
            .then((data) => {
                this.addValidations(data.Validation);
                callback();
            });
        } else {
            callback();
        }
    }

    saveData() {
        const self = this;
        let result = this.$services.monitor.transformAppData(self.financialReport.grantData);
        result = self.$services.monitor.mergeBudgetSummary(result, self.financialReport.applicationBudgetForGrant, self.financialReport.selectedReport.FinancialReportId);
        let selectedReport = self.financialReport.selectedKey;
        this.validationImport = false;
        this.saveReportData({
            data: result,
            id: self.financialReport.selectedReport.GrantId,
            reportId: self.financialReport.selectedReport.FinancialReportId,
            context: 'save',
            section: self.financialReport.selectedKey
        })
        .then((data) => {
            this.addValidations(data.Validation);
            });
    }

    /**  update the sub menu on left panel selection */
    subMenuChanged(selectedMenu, key) {
        this.saveDirty(() => {
            this.financialReport.selectedKey = key;
            window.location.hash = `#${this.financialReport.selectedKey}`;
        });
    }

    back() {
        var grantId = this.financialReport.selectedReport.GrantId.toString();
        this.$router.push({
            name: "grantSummary",
            params: { grantId: grantId }
        });
    }

    /** show validations */
    showValidation(msgs: any) {
        this.financialReport.validationMessages = msgs;
        this.financialReport.showValidationDilog = true;
    }

    // redirect to application form on validation message click
    validationMessageClicked(msg: any) {
        this.financialReport.showValidationDilog = false;
        this.financialReport.validationMessages = [];     
    }

    validationMessageClosed() {
        this.financialReport.showValidationDilog = false;
        this.financialReport.validationMessages = [];
    }

    /** pre validation action */
    preValidation() {
        const self = this;
        /** transform forecast model */
        let result = this.$services.monitor.transformAppData(self.financialReport.grantData);
        result = self.$services.monitor.mergeBudgetSummary(result, self.financialReport.applicationBudgetForGrant, self.financialReport.selectedReport.FinancialReportId);
        return this.saveReportData({
            data: result,
            id: self.financialReport.selectedReport.GrantId,
            reportId: self.financialReport.selectedReport.FinancialReportId,
            context: 'submit'
        }).then((data) => {
            this.addValidations(data.Validation);

            let validationErrors = [];

            // Get all errors
            Object.keys(data.Validation).forEach(key => {
            const item = data.Validation[key];
            if (item && item.Validation) {
                validationErrors = validationErrors.concat(item.Validation);
            }
            });
            
            return {validationErrors};
            });
    }

    /** computed property workflow items */
    get workFlowItems() {
        return this.financialReport.selectedReport.WorkflowInfo || {}
    }

    /** update the status */
    updateStatus(item) {
        this.financialReport.selectedReport.WorkFlowStatusId = item.StepId;
        this.financialReport.selectedReport.Comments = item.Comments;
        this.financialReport.selectedReport.Subject = item.Subject;
        this.financialReport.selectedReport.notify = item.notify;
        this.forecastValidations = [];
        this.saveReport({
            data: this.financialReport.selectedReport,
            id: this.financialReport.selectedReport.FinancialReportId
        }).then(() => { 
            this.$router.push({
                name: "grantSummary",
                params: { grantId: this.financialReport.selectedReport.GrantId.toString() }
            });        
        });
    }

    generateRowIds(dataModel) {
        dataModel.map(data => {
            data.rowId =  utils.generateGUID();
            return data;
        });
    }

    addValidations(data) {
        const self = this;
        let errFlag: boolean = false;

        // Process and add validations to each reports

        if (data.PersonnelCostResponse != null) {
            self.personnelCostValidations = data.PersonnelCostResponse.Validation;
            if (self.personnelCostValidations && self.personnelCostValidations.length > 0)
                errFlag = true;
        }
        if (data.TransactionListingResponse != null) {
            self.transactionValidations = data.TransactionListingResponse.Validation;
            if (self.transactionValidations && self.transactionValidations.length > 0)
                errFlag = true;
        }
        if (data.DetailedListingResponse != null) {
            self.detailedListingValidations = data.DetailedListingResponse.Validation;
            if (self.detailedListingValidations && self.detailedListingValidations.length > 0)
                errFlag = true;
        }
        if (data.DetailedExpensesResponse != null) {
            self.detailedExpenseValidations = data.DetailedExpensesResponse.Validation;
            if (self.detailedExpenseValidations && self.detailedExpenseValidations.length > 0)
                errFlag = true;
        }
        if (data.ForecastResponse != null) {
            self.forecastValidations = data.ForecastResponse.SeriesValidation;
            if (self.forecastValidations && self.forecastValidations.length > 0) {
                errFlag = true;
            }
        }

        // Notifications based on validation results
        if (errFlag)
            self.showNotification({
                text: self.$t('Validation errors. Please see respective tabs for error details.'),
                isHtml: true,
                color: "error"
            });
        else
            self.showNotification({
                text: self.$t('Saved successfuly.'),
                isHtml: true,
                color: "success"
            });
    }

    get forecastPeriod() {
        let date = "",
            index = this.finReports.findIndex(x=> x.FinancialReportId == this.financialReport.selectedReport.FinancialReportId),
            id = null;

        if (index + 1 <= this.finReports.length) {
            id = (this.finReports[index + 1] !== undefined ? this.finReports[index + 1].FinancialReportId : this.finReports[index].FinancialReportId) || null;
        }
        
        this.finReports.map((item: any) => {
            if(item.FinancialReportId == id) {
                date = `${this.$services.format.formatDate(item.StartDate)} - ${this.$services.format.formatDate(item.EndDate)}`
            }
        });
        return date;
    }
    /** watch method to refresh page on page load */
    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any, previousRoute: any) {
        var self = this;

        if(changedRoute && changedRoute.name === 'financialReport') {
            const reportId = changedRoute.params.financialReportId;
            // ???
            this.reportLength = changedRoute.params.reportLength;

            if(this.$route.hash)
                this.financialReport.selectedKey = this.$route.hash.substr(1);

            if(!previousRoute || previousRoute.name !== changedRoute.name || changedRoute.params.financialReportId !== previousRoute.params.financialReportId ) {
                this.personnelCostValidations = [];
                this.transactionValidations = [];
                this.forecastValidations = [];
                this.detailedExpenseValidations = [];
                this.detailedListingValidations =[];
                if(!this.$route.hash)
                    this.financialReport.selectedKey = "summary";
                    
                this.getReport(reportId).then((resp) => {
                resp.WorkflowInfo.CurrentStep.ReturnStatus
                    this.getGrantData(resp.GrantId).then((resp) => {
                        this.initiativeId = resp.meta.InitiativeId;
                    });
                    // list financial reports
                    this.$services.monitor.listFinancialReports(resp.GrantId)
                    .then((resp: any) => {
                        if(resp.Result === 'OK') {
                            this.finReports = resp.Record;
                        }
                    });
                    let params =  {
                            id : self.financialReport.selectedReport.GrantId,
                            financialReportId : self.financialReport.selectedReport.FinancialReportId,
                            period : self.financialReport.selectedReport.Title
                        }
                    self.getAppBudgetForGrant(params);
                });
                this.$services.document.documentTagBySection(['FINANCIAL REPORTS'])
                    .then((data) => {
                        this.docTags = data;
                    });

                this.getFeedbackInfo({ entity: _app.entities.finReport, transactionId: reportId });
            } else {
                window.location.hash = `#${this.financialReport.selectedKey}`;
            }
        }
    }
    
}
